import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input } from "antd";
import { jwtDecode } from "jwt-decode";
import Button from "../buttons/Button";
import FormLabel from "../formLabel/FormLabel";
import userServiceApi from "../../api/userServiceApi";
import { getRequest, postRequest } from "../../api/http";
import { SyncOutlined } from "@ant-design/icons";

export default function LoginForm() {
  const [loading, setLoading] = useState(false);
  const [loginAlert, setLoginAlert] = useState(false);
  const [wrongCred, setWrongCred] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const response = await postRequest(userServiceApi.login(), values);
      if (response) {
        const decoded = jwtDecode(response.accessToken);
        if (decoded?.role === "SUPER_ADMIN") {
          sessionStorage.setItem("token", response.accessToken);
          sessionStorage.setItem("refresh", response.refreshToken);
          sessionStorage.setItem("loginPage", "false");
          navigate("/admin");
        } else {
          setWrongCred(true)
          setLoading(false);
        }
      } else {
        setLoginAlert(true);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
console.log("loginAlert");
  return (
    <div className="login-form-container">
      <Form
        requiredMark={false}
        layout="vertical"
        form={form}
        className="form-container"
        onFinish={(values) => handleLogin(values)}
      >
        <Form.Item
          label={<FormLabel label="Email" className="form-label" />}
          name="email"
            normalize={(value) => value?.trim()}
          rules={[
            {
              required: true,
              message: "Please enter your Email",
            },
            {
              type: "email",
              message: "Invalid Email",
            },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          label={<FormLabel label="Password" className="form-label" />}
          name="password"
          rules={[
            {
              required: true,
              message: "Please enter your password",
            },
          ]}
        >
          <Input.Password placeholder="Enter password" />
        </Form.Item>
        {loginAlert ? (
          // console.log("alert")
          <label style={{ color: "red" }}>
            You have entered an invalid username or password
          </label>
        ) : wrongCred ? (
          <label style={{ color: "red" }}>
            Login using super admin credentials
          </label>
        ) : (
          ""
        )}
        <Button
          label="Login"
          width="100%"
          type="submit"
          className="login-button"
          loading={loading && <SyncOutlined spin />}
        />
      </Form>
    </div>
  );
}
